import { dynamicAssets } from 'js/constants/Paths';

export const parseHomepageData = (data) => {
  const { characters = {}, promo = {}, ctas = false } = data;

  const { image: promoImage = '' } = promo;
  const { image: charactersImage = '' } = characters;

  charactersImage !== '' && (characters.image = dynamicAssets(characters.image));
  promoImage !== '' && (promo.image = dynamicAssets(promo.image));

  if (ctas && ctas?.content?.length && ctas?.content?.length > 0) {
    ctas.content.forEach((cta) => {
      const { image = '' } = cta;
      image !== '' && (cta.image = dynamicAssets(image));
    });
  }

  return { ...data };
};
